<div class="wapper__expand wrapper__headerComponent container my-5">
  <div class="row align-items-center">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-6">
      <h2 class="text-center h3-tipografia-govco mb-0">
        {{ 'procesos.procesos-superfinanciera' | translate:{ entidad: nombreEntidad } }}
      </h2>
    </div>
    <div class="row align-items-center buscar-procesos">
      <form [formGroup]="form" class="row" (submit)="buscarExpediente()">
        <div class="col-12 col-md-4">
          <label for>{{ 'procesos.buscar-expediente' | translate }}</label>
        </div>
        <div class="col-12 col-md-8">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon1"
              ><i class="fa fa-search"></i
            ></span>
            <input
              type="text"
              class="form-control"
              formControlName="numeroProceso"
              aria-label="numeroProceso"
              aria-describedby="basic-addon1" />
          </div>
        </div>
      </form>
      <div class="row" *ngIf="showResult">
        <div class="col-12">
          <span
            >{{ 'procesos.resultado' | translate }}
            <a
              class="detalle-expediente"
              [routerLink]="[
                '/expediente/superfinanciera/',
                dataExpediente?.Id,
                dataExpediente?.Usuario_Id_Creador,
              ]"
              href="javascript:void(0)"
              >{{ 'procesos.expediente-con-no-proceso' | translate }}
              {{ proceso }}</a
            ></span
          >
        </div>
      </div>
      <div class="row" *ngIf="notFound">
        <div class="col-12 detalle-expediente">
          <span>{{ 'procesos.resultados-encontrados' | translate }}: 0</span>
        </div>
      </div>
      <br />
    </div>
    <br />
  </div>
  <app-power-bi-embed
    *ngIf="renderizarReporte"
    [embedUrl]="embedUrl"
    [embebedToken]="embedToken"
    [reportId]="reportId"
    [isMobile]="true"
    [heigth]="'1085px'"
    [groupId]="groupId"
    [accessToken]="accessToken">
  </app-power-bi-embed>
  <div class="row align-items-center descargar-tablas">
    <div class="col-12 col-md-3">
      <span class="descargar-tablas__titulo">{{
        'procesos.descargar-informacion-en-tablas' | translate
      }}</span>
    </div>
    <div class="col-12 col-md-3">
      {{ 'procesos.tramites-anio' | translate }}:
    </div>
    <div class="col-12 col-md-3">
      <select class="form-select" [(ngModel)]="selectedYear">
        <option *ngFor="let year of yearsFilter" [value]="year">
          {{ year }}
        </option>
      </select>
    </div>
    <div class="col-12 col-md-3">
      <button class="btn-govco outline-btn-govco" (click)="downloadExcel()"
        [attr.aria-label]="'descargar' | translate">
        {{ 'descargar' | translate }}
      </button>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-start mt-5">
    <div>
      <b
        id="metricas"
        class="btn btn-govco outline-btn-govco hvr-shrink"
        routerLink="/metricas-entidad"
        >{{ 'procesos.umbrales-metricas' | translate }}</b
      >
    </div>
  </div>
</div>
